import type { Ratings } from "@/types";

/** Keys aligned with API `Ratings` and i18n `ratings.*`. */
export enum RatingDimension {
  Services = "services",
  Support = "support",
  Website = "website",
  Pricing = "pricing",
  Performance = "performance",
}

export const RATING_DIMENSIONS: ReadonlyArray<{
  key: RatingDimension;
  labelKey: string;
}> = [
  { key: RatingDimension.Services, labelKey: "ratings.services" },
  { key: RatingDimension.Support, labelKey: "ratings.support" },
  { key: RatingDimension.Website, labelKey: "ratings.website" },
  { key: RatingDimension.Pricing, labelKey: "ratings.pricing" },
  { key: RatingDimension.Performance, labelKey: "ratings.performance" },
];

export function averageOverallRating(ratings: Ratings): number {
  return (
    (ratings.services +
      ratings.support +
      ratings.website +
      ratings.pricing +
      ratings.performance) /
    5
  );
}
